import React from 'react';
import { TaskForm } from '../TaskForm';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import Row from '../../../../shared/components/Row';
import { TaskCreateRequest } from './ws/TaskCreateRequest';
import { TaskCreateTask } from './ws/TaskCreateTask';
import Alert from 'react-s-alert';
import { PsRoutes } from '../../../../shared/routing/Routes';
import { bindActionCreators } from 'redux';
import * as navigationActions from '../../../../shared/utils/NavigationActions';
import { connect } from 'react-redux';
import Card from '../../../../shared/components/Card';
import CardSimpleHeader from '../../../../shared/components/CardSimpleHeader';
import CardBody from '../../../../shared/components/CardBody';

class TaskCreate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };
    }

    createTask = (values) => {
        const request = new TaskCreateRequest(values);

        this.setState({ loading: true });
        new TaskCreateTask(request)
            .onSuccess(() => {
                Alert.success(I18nUtils.tr('TR_TAREA_CREADA_CORRECTAMENTE'));
                this.setState({ loading: false });
                this.props.navigation.goTo(PsRoutes.MY_OUTSOURCES_TASKS);
            })
            .onFail(error => {
                Alert.error(error);
                this.setState({ loading: false });
            })
            .execute();
    };

    render() {
        return (
            <Row>
                <Card loading={this.state.loading}>
                    <CardSimpleHeader title={I18nUtils.tr('TR_NUEVA_TAREA')}/>
                    <CardBody>
                        <TaskForm onSubmit={this.createTask}/>
                    </CardBody>
                </Card>
            </Row>
        );
    }
}

const mapDispatchToProps = (dispatch) => ( { navigation: bindActionCreators(navigationActions, dispatch) } );

export const TaskCreateContent = connect(null, mapDispatchToProps)(TaskCreate);

TaskCreateContent.propTypes = {};

TaskCreateContent.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/form/create/TaskCreateContent.jsx